// extracted by mini-css-extract-plugin
export default {"container":"nav_customer_button-module__container--32Xq8"};